import React from 'react';
import { Badge, Box } from '../core';
import type { BoxProps } from 'theme-ui';

interface StrategyBadgesProps extends BoxProps {
  isVaultManager: boolean | undefined;
  isProposer: boolean | undefined;
  isStrategyManager: boolean | undefined;
  isGuardian: boolean | undefined;
}

function getVariant(x: boolean | undefined) {
  return x ? 'primary' : 'muted';
}

export const StrategyBadges = ({
  isVaultManager,
  isProposer,
  isGuardian,
  isStrategyManager,
  sx,
  ...rest
}: StrategyBadgesProps): JSX.Element => (
  <Box {...rest} sx={{ display: 'inline-block', ...sx }}>
    <Badge variant={getVariant(isProposer)} mr={2}>
      Proposer
    </Badge>
    <Badge variant={getVariant(isGuardian)} mr={2}>
      Guardian
    </Badge>
    <Badge variant={getVariant(isStrategyManager)} mr={2}>
      Strategy Manager
    </Badge>
    <Badge variant={getVariant(isVaultManager)} mr={2}>
      Vault Manager
    </Badge>
  </Box>
);
